import { render, staticRenderFns } from "./configuration-automation-preformatted-grid.vue?vue&type=template&id=049e580a&scoped=true&"
import script from "./configuration-automation-preformatted-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-preformatted-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-preformatted-grid.scss?vue&type=style&index=0&id=049e580a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e580a",
  null
  
)

export default component.exports